import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import Guard from '@/components/layouts/guard';
import apiConfig from '@/config/url-api';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search);
      const codeFromUrl = searchParams.get('code') || (location.search as any)?.code;
      if (codeFromUrl) {
        window.localStorage.setItem(apiConfig.auth.storageTokenKeyName, String(codeFromUrl));
      }

      // Embed page handles its own authentication state and "Akses Ditolak" UI
      if (location.pathname.startsWith('/apps-embed')) {
        return;
      }

      const token = window.localStorage.getItem(apiConfig.auth.storageTokenKeyName);
      if (!token) {
        throw redirect({
          to: '/login',
          search: {
            returnUrl: location.href,
          },
        });
      }
    }
  },
  component: () => (
    <Guard authGuard={true} guestGuard={false}>
      <Outlet />
    </Guard>
  ),
});
